import type {
  MarketplaceCapability,
  MarketplaceSubscription,
  SelectedMarketplaceRequest,
} from "../types/marketplace";

/** Active subscriptions open an Expand Coverage request. */
export function toExpansionRequest(
  subscription: MarketplaceSubscription,
): SelectedMarketplaceRequest {
  return {
    id: subscription.id,
    name: subscription.name,
    description: subscription.description,
    requestType: "expansion",
  };
}

/** Available capabilities open a Request More Information request. */
export function toInformationRequest(
  capability: MarketplaceCapability,
): SelectedMarketplaceRequest {
  return {
    id: capability.id,
    name: capability.name,
    description: capability.description,
    requestType: "information",
    eligible: capability.eligible,
    whyRecommended: capability.whyRecommended,
  };
}
